<template>
  <div class="card" style="max-width: 700px; margin: auto">
    <div class="card-content">
      <p class="title">
        {{ $t("signUp") }}
      </p>
      <form ref="form" action="onSubmit">
        <b-message v-if="$route.params.reroute == 'agency'" type="is-primary">
          {{ $t("AgencyCreateUserFirstExplained") }}
        </b-message>
        <b-field :label="$t('title')">
          <b-select v-model="formData.title" :placeholder="$t('nA')">
            <option value="ms">
              {{ $t("ms") }}
            </option>
            <option value="mr">
              {{ $t("mr") }}
            </option>
            <option :value="null">
              {{ $t("nA") }}
            </option>
          </b-select>
        </b-field>
        <b-field :label="$t('firstName')">
          <b-input v-model="formData.firstName" required />
        </b-field>
        <b-field :label="$t('lastName')">
          <b-input v-model="formData.lastName" required />
        </b-field>

        <b-field :label="$t('email')">
          <b-input v-model="formData.email" type="email" required />
        </b-field>
        <b-field :label="$t('password')">
          <b-input v-model="formData.password" type="password" pattern=".{6,}" required />
        </b-field>
        <password v-model="formData.password" :strength-meter-only="true" />
        <p>
          <small>
            {{ $t("passwordInfo") }}
            <small
          /></small>
        </p>
        <b-field :label="$t('repeatpassword')" :type="passwordError ? 'is-danger' : ''">
          <b-input ref="repeatpassword" v-model="repeatpassword" type="password" required />
        </b-field>
        <b-field :label="$t('telephoneNumber')" />
        <PhoneNumberPicker v-model="formData.telephoneNumber" :required="formData.mobileNumber ? false : true" />
        <b-field :label="$t('mobileNumber')" />
        <PhoneNumberPicker v-model="formData.mobileNumber" :required="formData.telephoneNumber ? false : true" />

        <div style="max-width: 750px; margin-left: auto; margin-right: auto" class="is-clearfix my-5">
          <div class="field" style="max-width: 400px">
            <b-checkbox v-model="checkAgb">
              <span v-html="$t('agbCheck')" />
            </b-checkbox>
          </div>
          <div class="mt-4">
            <b-button type="is-primary" :disabled="isDisabled || !checkAgb" @click.prevent="onSubmit">
              {{ $t("signUp") }}
            </b-button>
            <slot />
          </div>
        </div>
      </form>
    </div>
    <b-loading :active.sync="isLoading" :is-full-page="false" :can-cancel="false" />
  </div>
</template>

<script>
import { auth, functions } from "@/firebase";
import Password from "vue-password-strength-meter";
import PhoneNumberPicker from "@/components/PhoneNumberPicker";

export default {
  name: "RegistrationCardAdmin",
  components: {
    Password,
    PhoneNumberPicker,
  },
  data() {
    return {
      isDisabled: true,
      isLoading: false,
      repeatpassword: "",
      passwordError: false,
      checkAgb: false,
      formData: {
        title: null,
        firstName: "",
        email: "",
        password: "",
        telephoneNumber: "",
        mobileNumber: "",
      },
      ref: null,
    };
  },
  watch: {
    // this works only with html5 validation
    // keep the submit button disabled as long as the form is invalid
    formData: {
      deep: true,
      handler() {
        const valid = this.$refs.form.checkValidity() && !this.passwordError;
        this.isDisabled = !valid;
      },
    },
    // check that both passwords are the same
    repeatpassword: function () {
      if (this.repeatpassword !== this.formData.password) {
        this.passwordError = true;
      } else {
        this.passwordError = false;
      }

      const valid = this.$refs.form.checkValidity() && !this.passwordError;
      this.isDisabled = !valid;
    },
  },
  methods: {
    async onSubmit() {
      if (this.isDisabled) return;

      this.isDisabled = true;
      this.isLoading = true;

      //checks
      /**
       * @todo some validity checks
       */

      // check for referral link
      if (localStorage.ref) {
        this.ref = localStorage.ref;
      }

      // create user
      try {
        await auth.createUserWithEmailAndPassword(this.formData.email, this.formData.password);
        await functions.httpsCallable("SetUserInformation")({
          title: this.formData.title,
          firstName: this.formData.firstName,
          lastName: this.formData.lastName,
          email: this.formData.email,
          mobileNumber: this.formData.mobileNumber,
          telephoneNumber: this.formData.telephoneNumber,
          ref: this.ref,
        });
        this.$buefy.toast.open({
          message: this.$t("registrationSucceed"),
          type: "is-success",
          duration: 4000,
        });

        this.isLoading = false;
        this.$emit("registrationSuccessful");
      } catch (error) {
        let translated_errors = ["auth/email-already-in-use", "auth/invalid-email", "auth/weak-password"];
        if (translated_errors.includes(error.code)) {
          this.$buefy.toast.open({
            message: this.$t(error.code),
            type: "is-danger",
          });
        } else {
          this.$buefy.toast.open({
            message: this.$t("registrationFailed"),
            type: "is-danger",
          });
        }
        this.isDisabled = false;
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped></style>
